module.exports = __webpack_public_path__ + "assets/language-squares/ko-61d0e1207f327542bc3b75d05edbaa67.jpg";